import { useCreateNightscoutSource as useCreateNightscoutSourceAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"

import { useSources } from "./useSources"
import { useFollowedUsers } from "src/contexts"
import { useEventReloading } from "src/contexts/LoadingContexts"
import { noticeError } from "src/utils"

export function useCreateNightscoutSource() {
  const { selfFollow } = useFollowedUsers()
  const createNightscoutSource = useCreateNightscoutSourceAPI()
  const { mutate } = useSources()
  const { requestReload } = useEventReloading()

  const selfFollowId = selfFollow.id

  const createSource = useMemo(
    () => !createNightscoutSource ? undefined : async (source: Parameters<typeof createNightscoutSource>[0]) => {
      try {
        const response = await createNightscoutSource(source)

        void mutate()
        requestReload(selfFollowId)

        return response
      } catch (e) {
        noticeError(
          e,
          "CreateSource",
          { source },
        )

        throw e
      }
    },
    [
      requestReload,
      createNightscoutSource,
      mutate,
      selfFollowId,
    ],
  )

  return createSource
}
